// Auto-generated from gen_pet_names.ts
// DO NOT EDIT THIS FILE DIRECTLY

import { Lang } from './languages';

type PetData = {
  [name in Lang]: readonly string[];
};

const data: PetData = {
  'cn': [
    '绿宝石兽',
    '黄宝石兽',
    '朝日小仙女',
    '夕月小仙女',
    '车式浮空炮塔',
    '象式浮空炮塔',
    '亚灵神巴哈姆特',
    '亚灵神不死鸟',
    '炽天使',
    '月长宝石兽',
    '英雄的掠影',
    '后式自走人偶',
    '分身',
    '宝石兽',
    '红宝石兽',
    '伊弗利特之灵',
    '泰坦之灵',
    '迦楼罗之灵',
    '红宝石伊弗利特',
    '黄宝石泰坦',
    '绿宝石迦楼罗',
    '琥珀宝石兽',
    '黑曜宝石兽',
    '烈日巴哈姆特',
  ],
  'de': [
    'Smaragd-Karfunkel',
    'Topas-Karfunkel',
    'Eos',
    'Selene',
    'Selbstschuss-Gyrocopter TURM',
    'Selbstschuss-Gyrocopter LÄUFER',
    'Demi-Bahamut',
    'Demi-Phönix',
    'Seraph',
    'Mondstein-Karfunkel',
    'Schattenschemen',
    'Automaton DAME',
    'Gedoppeltes Ich',
    'Karfunkel',
    'Rubin-Karfunkel',
    'Ifrit-Egi',
    'Titan-Egi',
    'Garuda-Egi',
    'Rubin-Ifrit',
    'Topas-Titan',
    'Smaragd-Garuda',
    'Bernstein-Karfunkel',
    'Obsidian-Karfunkel',
    'Sol-Bahamut',
  ],
  'en': [
    'Emerald Carbuncle',
    'Topaz Carbuncle',
    'Eos',
    'Selene',
    'Rook Autoturret',
    'Bishop Autoturret',
    'Demi-Bahamut',
    'Demi-Phoenix',
    'Seraph',
    'Moonstone Carbuncle',
    'Esteem',
    'Automaton Queen',
    'Bunshin',
    'Carbuncle',
    'Ruby Carbuncle',
    'Ifrit-Egi',
    'Titan-Egi',
    'Garuda-Egi',
    'Ruby Ifrit',
    'Topaz Titan',
    'Emerald Garuda',
    'Amber Carbuncle',
    'Obsidian Carbuncle',
    'Solar Bahamut',
  ],
  'fr': [
    'Carbuncle émeraude',
    'Carbuncle topaze',
    'Eos',
    'Selene',
    'Auto-tourelle Tour',
    'Auto-tourelle Fou',
    'Demi-Bahamut',
    'Demi-Phénix',
    'Séraphin',
    'Carbuncle hécatolite',
    'Estime',
    'Automate Reine',
    'Ombre',
    'Carbuncle',
    'Carbuncle rubis',
    'Ifrit-Egi',
    'Titan-Egi',
    'Garuda-Egi',
    'Ifrit rubis',
    'Titan topaze',
    'Garuda émeraude',
    'Carbuncle ambre',
    'Carbuncle obsidienne',
    'Sol-Bahamut',
  ],
  'ja': [
    'カーバンクル・エメラルド',
    'カーバンクル・トパーズ',
    'フェアリー・エオス',
    'フェアリー・セレネ',
    'オートタレット・ルーク',
    'オートタレット・ビショップ',
    'デミ・バハムート',
    'デミ・フェニックス',
    'セラフィム',
    'カーバンクル・ムーンストーン',
    '英雄の影身',
    'オートマトン・クイーン',
    '分身',
    'カーバンクル',
    'カーバンクル・ルビー',
    'イフリート・エギ',
    'タイタン・エギ',
    'ガルーダ・エギ',
    'イフリート・ルビー',
    'タイタン・トパーズ',
    'ガルーダ・エメラルド',
    'カーバンクル・アンバー',
    'カーバンクル・オブシダン',
    'ソルバハムート',
  ],
  'ko': [
    '카벙클 에메랄드',
    '카벙클 토파즈',
    '요정 에오스',
    '요정 셀레네',
    '자동포탑 룩',
    '자동포탑 비숍',
    '데미바하무트',
    '데미피닉스',
    '세라핌',
    '카벙클 문스톤',
    '영웅의 환영',
    '자동인형 퀸',
    '분신',
    '카벙클',
    '카벙클 루비',
    '이프리트 에기',
    '타이탄 에기',
    '가루다 에기',
    '이프리트 루비',
    '타이탄 토파즈',
    '가루다 에메랄드',
    '카벙클 앰버',
    '카벙클 옵시디언',
    '솔 바하무트',
  ],
  'tc': [
    '卡邦庫爾-綠寶石',
    '卡邦庫爾-黃寶石',
    '朝日小仙女',
    '夕月小仙女',
    '車型浮游砲塔',
    '象型浮游砲塔',
    '亞靈神巴哈姆特',
    '亞靈神鳳凰',
    '熾天使',
    '卡邦庫爾-月長石',
    '英雄的掠影',
    '后型自走人偶',
    '分身',
    '卡邦庫爾',
    '卡邦庫爾-紅寶石',
    '伊弗利特-艾基',
    '泰坦-艾基',
    '迦樓羅-艾基',
    '伊弗利特-紅寶石',
    '泰坦-黃寶石',
    '迦樓羅-綠寶石',
    '卡邦庫爾-琥珀石',
    '卡邦庫爾-黑曜石',
    '烈日巴哈姆特',
  ],
};

export default data;
